import React, {useEffect, useState} from "react";
import {callAPI, useAPI} from "../../../lib/common";

const RecentImagesContext = React.createContext()

const RecentImagesProvider = (props) => {
    const [fetchedRecentImages, loadingImages] = useAPI('/m/api/user/recent-images');
    const [recentImages, setRecentImages] = useState(null);

    useEffect(() => {
        if (fetchedRecentImages) {
            setRecentImages(fetchedRecentImages);
        }
    }, [fetchedRecentImages]);

    const addImage = (image) => {
        setRecentImages(recentImages => {
            return [
                ...recentImages,
                image
            ]
        })
    }

    const getImageInfoByUuid = (uuid) => {
        return recentImages.find(image => image.uuid == uuid)
    }

    console.log('Recent images', recentImages);

    return (
        <RecentImagesContext.Provider value={
            {addImage, loadingImages, recentImages, getImageInfoByUuid}
        }
                                      {...props} />
    )
}


const useRecentImages = () => React.useContext(RecentImagesContext)
export {RecentImagesProvider, useRecentImages}
